import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ideastock() {
  return (
    <section className="idea_stock p-100 text_white bg_stock text_stock">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h1>
              THE CONCEPT BEHIND <span>STOCK N SHIP</span>
            </h1>
            <p>
              The client sought an alternative, all-in-one platform where
              stores, suppliers, and the administration could get a deeper look
              into product logistics and distribution processes and how
              consumers get access.
            </p>
            <p>
              The idea of Stock n Ship is to be an intermediary and enable
              businesses to navigate better through their state-of-the-art
              portals.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <div className="idea_stock text-center">
              <StaticImage
                src="../../../images/case-studies/stock/idea.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1076}
                height={586}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ideastock;
